// extracted by css-extract-rspack-plugin
export default {"TriggerContainer":"Qra6V","TriggerContainerIcon":"bFuWL","TextSchema":"NjfCF","BackButtonLabel":"QvyG4"};